import React from 'react';


const EmployeeOverviewStatusCard = ({noOfOrdersClassName, dropDown, cardTitle, cardSubtitle, cardNumber}) => {

    return (
        <section>
            <div className='order-status-card-container employee-overview-card-container'>
                <div className='flex gap-4'>
                    <p className='due-text'>{cardTitle}</p>
                    <section>
                        {dropDown}
                    </section>
                </div>
                <div className='flex gap-20 mt-12'>
                    <div>
                        <p className={`no-of-orders employee-card-number ${noOfOrdersClassName}`}>{cardNumber} <span className='orders-text'>{cardSubtitle}</span> </p>
                    </div>
                   
                </div>
                
            </div>
        </section>
    );
}

export default EmployeeOverviewStatusCard;
